import { Platform } from 'react-native';

const isAndroid = Platform.OS === 'android';
const isIos = Platform.OS === 'ios';
const isWeb = Platform.OS === 'web';
const isMobile = isAndroid || isIos;

export { isAndroid, isIos, isWeb, isMobile };
